SP.ProductPage = Garnish.Base.extend({
    $page: null,
    $form: null,

    $qtyBtn: null,
    $qtyInput: null,
    currentQty: 1,

    $productInfoNav: null,
    $productInfoNavMenu: null,
    $productInfoNavCurrentItem: null,

    // Slideshow
    productImageSlideshow: null,

    // Product
    product: null,

    // Variant
    defaultVariant: false,
    variant: null,

    // Product Options
    $productSelect: null,
    $productOptionGroup: null,
    optionRadioGroups: null,

    // Cart Form
    $addToCartBtn: null,
    $cartResponse: null,

    // Product Recommendations
    $productRecommendationsContainer: null,
    productRecommendations: null,

    // Product Notify
    $notifyFormContainer: null,
    $notifyEmail: null,
    $notifyBtn: null,

    init(page) {
        this.$page = $(page)
        this.$form = $('#AddToCartForm')
        this.$addToCartBtn = this.$form.find('#add-to-cart')
        this.$cartResponse = this.$form.find('.add-to-cart-response')

        this.$productInfoNav = $('.product-info-nav')
        this.$productInfoNavCurrentItem = $('.mobile-current-nav-item')
        this.$productInfoNavMenu = this.$productInfoNav.find('ul')

        // Product & Variants
        // TODO: Remove
        // this.product = product
        this.variants = product.variants
        this.variant = currentVariant

        // Init Product Image Slideshow
        this.initProductImageSlideshow()

        // Product Back in Stock Notification Form
        this.$notifyFormContainer = this.$page.find('.product-notify')
        this.$notifyEmail = this.$notifyFormContainer.find('#notify_email')
        this.$notifyBtn = this.$notifyFormContainer.find('#notify_button')
        this.addListener(this.$notifyBtn, 'click', this.handleNotifyBackInStock)

        // Init Options/Variants Selectors
        this.$productSelect = this.$page.find('#product-select')
        this.optionRadioGroups = []
        this.$productOptionGroup = this.$page.find('.product-option')
        for (let i = 0; i < this.$productOptionGroup.length; ++i) {
            let org = new SP.OptionRadioGroup(this.$productOptionGroup[i], this)
            this.optionRadioGroups.push(org)
        }
        this.updateProductForm()
        this.addListener(this.$productSelect, 'change', this.handleProductSelect)

        // Quantity
        this.$qtyBtn = this.$form.find('.update-qty')
        this.$qtyInput = this.$form.find('#quantity')
        this.currentQty = parseInt(this.$qtyInput.val())


        // Product Recommendations
        this.$productRecommendationsContainer = $('#product-recommendations')
        this.productRecommendations = new SP.ProductRecommendations(this)

        // Location inventories
        this.productCustomizerInit()

        this.addListener(this.$qtyBtn, 'click', this.handleQtyChange)
        this.addListener(this.$form, 'submit', this.processCart)
        this.addListener(this.$productInfoNavCurrentItem, 'click', this.openProductInfoMenu)
    },

    productCustomizerInit() {
        // let variantInventoryEndpoint = `https://06db5c8f43041a955c1d3b450ce303d7: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@snow-peak-staging.myshopify.com/admin/api/2021-01/variants/${this.variantId}.json`

        // $.getJSON(variantInventoryEndpoint, function(data) {
        //     console.log(data)
        // })

  //       let query = `{
  //   product(id: "gid://shopify/Product/4593160159276") {
  //     title
  //     description
  //     onlineStoreUrl
  //   }
  // }`;
  //
  //       $.ajax( {
  //           // url: 'https://snowpeak.com//admin/api/2021-01/graphql.json',
  //           url: variantInventoryEndpoint,
  //           method: 'GET',
  //           // data: JSON.stringify({query}),
  //           headers: {"X-Shopify-Access-Token": "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"},
  //           crossDomain: true,
  //           success: function(response){
  //               console.log(response);
  //           }
  //       })

        // let inventoryEndpoint = `https://06db5c8f43041a955c1d3b450ce303d7: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@snow-peak-staging.myshopify.com/admin/api/2021-01/inventory_levels.json?inventory_item_ids=34179576234028&location_ids=44817678380`
        //
        // if (this.product) {
        // }
    },

    handleNotifyBackInStock(e) {
        let self = this
        e.preventDefault()
        let email = this.$notifyEmail.val()
        let productId = product.id
        let variantId = this.$notifyFormContainer.data('variant-id') || this.variant.id

        BIS.create(email, variantId, productId).then(self.bisNotificationCallback)
    },

    bisNotificationCallback(data) {
        let msg = ''
        if (data.status === 'OK') {
            msg = data.message
            ga('send', 'event', 'Product Detail Page', 'Back In Stock - Notify', product.title);
        } else { // it was an error
            for (let k in data.errors) {
                msg += data.errors[k].join()
            }
        }
        $('.product-notify').append('<p class="alert">'+msg+'</p>')
        setTimeout(function(){
                $('p.alert').fadeOut('slow',function(){
                    $(this).remove()
                })
            },
            10000)
    },

    initProductImageSlideshow() {
        this.productImageSlideshow = new Swiper('.product-image-slider', {
            direction: 'horizontal',
            loop: true,
            mousewheel: true,
            autoHeight: true,
            height: 450,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                1024: {
                    direction: 'vertical',
                    height: 600,
                },
                1800: {
                    direction: 'vertical',
                    height: 600,
                },
            }
        })

        this.updateProductSlide()
    },

    handleProductSelect() {
        let variantId = this.$productSelect.val()
        this._setVariant(variantId)

        this.updateProductSlide()
        this.updateProductForm()
    },

    updateProductSlide() {
        if (this.variant.featured_image) {
            let imageId = this.variant.featured_image.id
            let slide = $(`[data-slider-image-id="${imageId}"]`)

            if (slide) {
                let slideIndex = slide.data('swiper-slide-index')
                this.productImageSlideshow.slideTo(slideIndex + 1)
            }
        }
    },

    updateProductForm() {
        // Check if variant is available
        if (this.variant.available) {
            this.$addToCartBtn.prop('disabled', false).html('Add To Cart').removeClass('btn-disabled').attr('aria-disabled', false)
            this.$notifyFormContainer.hide()
        } else {
            this.$addToCartBtn.prop('disabled', true).html('Sold Out').addClass('btn-disabled').attr('aria-disabled', true)
            this.$notifyFormContainer.show().attr('data-variant-id', this.variant.id);
        }

        // Update price
        if (product.compare_at_price > product.price) {
            let priceEl = $(`<span class="sale-price" itemprop="price">${Shopify.formatMoney(this.variant.price, '')}</span><span class="crossed-out">${Shopify.formatMoney(this.variant.compare_at_price, '')}</span>`)
            $('.product-price').html(priceEl)
        } else {
            $('.product-price').html(`${Shopify.formatMoney(this.variant.price, '')}`)
        }
    },

    handleQtyChange(ev) {
        let type = $(ev.currentTarget).data('type')
        this.currentQty = parseInt(this.$qtyInput.val())

        if (type === 'increase') {
            this.increaseQuantity()
        }

        if (type === 'decrease') {
            this.decreaseQuantity()
        }
    },

    openProductInfoMenu() {
        this.$productInfoNavMenu.toggleClass('active')

        if (this.$productInfoNavMenu.hasClass('active')) {
            this.addListener($('body'), 'click', this.closeProductInfoMenu)
        } else {
            this.removeListener($('body'), 'click')
        }
    },

    closeProductInfoMenu(ev) {
        if (!this.$productInfoNav.is(ev.target) && this.$productInfoNav.has(ev.target).length === 0 && this.$productInfoNavMenu.hasClass('active')) {
            this.$productInfoNavMenu.removeClass('active')
            this.removeListener($('body'), 'click')
        }
    },

    verifyQtyChange() {
        if (this.currentQty <= 0) {
            this.$qtyInput.val(1)
        }
    },

    increaseQuantity() {
        this.$qtyInput.val(this.currentQty + 1)
    },

    decreaseQuantity() {
        if (this.currentQty === 1) {
            this.$qtyInput.val(1)
        } else {
            this.$qtyInput.val(this.currentQty - 1)
        }
    },

    processCart(e) {
        let self = this
        e.preventDefault()

        this.$cartResponse.html('').removeClass('has-error').removeClass('has-success')

        let payload = {
            quantity: this.$qtyInput.val(),
            id: this.variant.id
        }

        $.post('/cart/add.js', payload, null, "json").done(function () {
            toastr.success(product.title + ' has been added to cart', 'Cart Updated')
            self.$cartResponse.html(`Item added to your cart`).addClass('has-success')
            ga('send', 'event', 'Product Detail Page', 'Add To Cart Click', product.title);
        }).fail(function ($xhr) {
            let data = $xhr.responseJSON
            toastr.success(data.description, data.message)
        })

        
    },

    _setVariant(variantId) {
        this.variant = this.variants.find(v => v.id === parseInt(variantId))
    }
})

